import * as React from 'react';

const ItalicChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15.2 17c-.3.7-.9 1.5-1.6 2.3-.7.8-1.6 1.2-2.7 1.2-.7 0-1.3-.2-1.6-.5-.4-.4-.5-.8-.5-1.3s.2-1.2.5-2.1l1.7-4.5c.2-.4.2-.7.2-.8 0-.1 0-.2-.1-.3-.1-.1-.2-.1-.3-.1-.3 0-.6.2-1 .7-.4.4-.6.8-.8 1.2H7.9c.5-1.1 1.2-2 2-2.6.8-.6 1.6-.9 2.4-.9.6 0 1 .1 1.4.4.4.3.6.7.6 1.1 0 .5-.1 1-.3 1.5l-2 5.4c-.1.4-.2.7-.2.9 0 .1 0 .2.1.3.1.1.2.1.3.1.3 0 .5-.1.8-.4.3-.3.6-.8 1-1.5h1.2zM16.1 5.2c0 .5-.2.9-.5 1.2-.3.3-.7.5-1.2.5s-.9-.2-1.2-.5c-.3-.3-.5-.7-.5-1.2 0-.4.2-.8.5-1.2.3-.3.7-.5 1.2-.5.3 0 .6.1.8.2.3.2.5.3.6.6.2.3.3.5.3.9z"
        />
    </svg>
);

ItalicChunkySvg.displayName = 'ItalicChunkySvg';
export default ItalicChunkySvg;
